export enum EnumUserRole {
    User = 0,
    Administrator = 1
}
